import { useSuspenseQuery } from '@tanstack/react-query';
import { useGetTemplate } from './template.ts';
import { getStaleTimeInHours } from '@/shared/utils/staleTime.ts';

const STALE_TIME = getStaleTimeInHours(1);

export const useTemplate = (templateId: string) => {
    const { getTemplate } = useGetTemplate();

    return useSuspenseQuery({
        queryKey: ['template', templateId],
        queryFn: async () => getTemplate(templateId),
        refetchOnWindowFocus: false,
        staleTime: STALE_TIME,
    });
};
